import React from "react";
import { useNavigate } from "react-router-dom";
import { useGetJournalStatus } from "../../Controllers/DashboardController";
import Am from "../DashboardJournal/DashboardAm";
import Pm from "../DashboardJournal/DashoardPm";
import CardSkeletonLoader from "../SkeletonLoaders/CardSkeletonLoader";

const DailyJournalSection = () => {
  const navigate = useNavigate();
  const {
    data: journalStatusAm,
    isLoading: amLoading,
    isError: amError,
  } = useGetJournalStatus("am");
  const {
    data: journalStatusPm,
    isLoading: pmLoading,
    isError: pmError,
  } = useGetJournalStatus("pm");

  const journalStatus = {
    am: journalStatusAm?.is_completed || false,
    pm: journalStatusPm?.is_completed || false,
  };

  const handleAmJournalClick = () => navigate("/reflection-journal/am");
  const handlePmJournalClick = () => navigate("/reflection-journal/pm");

  if (amError || pmError) return null;

  if (amLoading || pmLoading) {
    return (
      <div className="row g-2">
        <CardSkeletonLoader height="140px" />
        <CardSkeletonLoader height="140px" />
      </div>
    );
  }

  return (
    <div className="d-flex flex-column gap-2">
      <Am
        highlighted={!journalStatus.am}
        status={journalStatus.am}
        onClick={handleAmJournalClick}
      />
      <Pm
        highlighted={!journalStatus.pm}
        status={journalStatus.pm}
        onClick={handlePmJournalClick}
      />
    </div>
  );
};

export default DailyJournalSection;
